import {useMemo} from "react";

export const useMap = <T extends {id: number | string}>(list: T[]): Record<number | string, T> => {
    return useMemo(() => {
        const listMap: Record<number | string, T> = {};

        for (const item of list) {
            listMap[item.id] = item;
        }

        return listMap;
    }, [list]);
};
import {useMemo} from "react";

export const useMap = <T extends {id: number | string}>(list: T[]): Record<number | string, T> => {
    return useMemo(() => {
        const listMap: Record<number | string, T> = {};

        for (const item of list) {
            listMap[item.id] = item;
        }

        return listMap;
    }, [list]);
};
